import { usePersistence } from '@segments/Storage'
import * as React from 'react'

import { OrderNoteInput as SharedOrderNoteInput } from '~shared/segments/FormScreen'

type TProps = NoChildren

/**
 * Wrapper for note input used on the Form screen.
 */
export const OrderNoteInput: React.FC<TProps> = () => {
  const [, persistNote] = usePersistence<string>({ key: `note` })

  return <SharedOrderNoteInput persistNote={persistNote} />
}
